import { Transform, Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { User } from "./user.model";

export class UserImpersonate extends BaseModel {
  id: number;
  actualUserId: string; // Unique identifier for the user doing the impersonation
  userBeingImpersonatedId: string; // Unique identifier for the user being impersonated
  @Type(() => User)
  actualUser?: User;
  @Type(() => User)
  userBeingImpersonated?: User;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  impersonationReason?: string;
  endTime?: number;
}
